import { client2 } from "@/config/axios-wrapper";

type StripeProduct = {
  id: string;
  object: string;
  active: boolean;
  attributes: any[];
  created: number;
  default_price: string;
  description: null;
  features: any[];
  images: any[];
  livemode: boolean;
  marketing_features: any[];
  metadata: Record<string, unknown>;
  name: string;
  package_dimensions: null;
  shippable: null;
  statement_descriptor: null;
  tax_code: string;
  type: string;
  unit_label: null;
  updated: number;
  url: null;
  price: {
    id: string;
    object: string;
    active: boolean;
    billing_scheme: string;
    created: number;
    currency: string;
    custom_unit_amount: null;
    livemode: boolean;
    lookup_key: null;
    metadata: Record<string, unknown>;
    nickname: null;
    product: string;
    recurring: {
      aggregate_usage: null;
      interval: string;
      interval_count: number;
      meter: null;
      trial_period_days: number;
      usage_type: string;
    };
    tax_behavior: string;
    tiers_mode: null;
    transform_quantity: null;
    type: string;
    unit_amount: number;
    unit_amount_decimal: string;
  };
  revenuecat_product: {
    description: string;
    features: {
      job_post: number;
      shortlist: number;
    };
    features_list: string[];
    has_trial: boolean;
    id: string;
    name: string;
  };
};

export const getStripeProducts = async (productIds: string[]) => {
  const response = await client2.get<{
    success: boolean;
    result: StripeProduct[];
  }>(`/stripe/products?productIds=${JSON.stringify(productIds)}`);

  return response.data.result;
};
